<template lang="pug">
form(@submit.prevent="submit")
  fieldset(:disabled="loading")
    modal(:active='active', @close='close', title='Nova mensagem', v-if='active')
      div(slot="modal-body")
        .columns
          .column.col-8.col-sm-12
            form-group(
              :label='"mensagem.destinatario" | tModel',
              :validation='$v.form.destinatario_id'
            )
              pessoa-picker(style="padding-top: 6px" preload-disabled v-model='$v.form.destinatario_id.$model')
          .column.col-4.col-sm-12
            form-group(
              :label='"mensagem.prioridade" | tModel',
              :validation='$v.form.prioridade'
            )
              select.form-select(v-model="$v.form.prioridade.$model")
                option(:value="4") Baixa
                option(:value="3") Média
                option(:value="2") Alta
                option(:value="1") Máxima
        .divider
        form-group(
          :label="'mensagem.titulo' | tModel"
          :validation="$v.form.titulo"
        )
          input.form-input(v-model="$v.form.titulo.$model")
        form-group(
          :label='"mensagem.conteudo" | tModel'
          :validation="$v.form.conteudo"
        )
          textarea.form-input(v-model="$v.form.conteudo.$model")
      div(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.form.$invalid || loading" :class="{ loading }")
          i.fa.fa-paper-plane
          |  Enviar
</template>

<script>
import PessoaPicker from "@/components/pickers/PessoaPicker"
import { required, minLength } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"

const INITIAL_FORM = () => ({
  assunto_id: null,
  destinatario_id: null,
  prioridade: 3,
  titulo: "",
  conteudo: "",
})

export default {
  vuex: {
    "mensagens/enviadas": {
      actions: ["fetchCreate"],
      getters: ["loading"],
    },
  },
  data() {
    return {
      active: false,
      form: INITIAL_FORM(),
    }
  },
  components: { PessoaPicker },
  validations: {
    form: {
      destinatario_id: { required },
      prioridade: { required },
      titulo: { required },
      conteudo: { required, minLength: minLength(10) },
    },
  },
  methods: {
    async submit() {
      try {
        await this.fetchCreate(this.form)
        this.$toaster.success("Mensagem enviada")
        this.close()
      } catch (e) {
        toastErrors(e)
      }
    },
    show() {
      this.active = true
    },
    close() {
      this.active = false
      this.form = INITIAL_FORM()
      this.$v.$reset()
    },
  },
}
</script>
